import React from 'react'

const React_Coding_Practice_4 = () => {
  return (
    <div>
      <h1>Coding Pratice 4</h1>
    </div>
  )
}

export default React_Coding_Practice_4
